export default __webpack_public_path__ + "9d5132ac3af7c4ced78d9b2f298a370d.webp";